import { Order } from '@blade/std-lib'
import { DelugeId } from '@root/entities/user-short'

import { AttachmentId } from './attachment-id'
import { SupportTicketId } from './support-ticket-id'
import { SupportTicketMessageId } from './support-ticket-message-id'

import type {
  SupportTicketsListData,
  SupportTicketsMessagesListData,
} from '@blade/trade-api-client'

type TicketDto = SupportTicketsListData['data'][number]
export type Status = TicketDto['status']
export type MessageDto = SupportTicketMessageDto

// TODO: Val - use backend attachment type, when it will be available
export type AttachmentDto = {
  id: AttachmentId
  url: string
  fileName: string
}

type SupportTicketMessageDto =
  SupportTicketsMessagesListData['data'][number] & {
    attachments?: Array<{
      id: string
      url: string
      fileName: string
    }>
  }

export type Message = {
  id: SupportTicketMessageId
  ticketId: SupportTicketId
  delugeId: DelugeId
  authorType: 'user' | 'support' | 'system'
  authorId?: string
  text: string
  bridge?: 'in-app' | 'telegram' | 'email'
  createdAt: Date
  updatedAt: Date
  attachments?: Array<AttachmentDto>
}

export const fromDto = (dto: SupportTicketMessageDto): Message => {
  return {
    id: SupportTicketMessageId(dto.id),
    ticketId: SupportTicketId(dto.ticketId),
    delugeId: DelugeId(dto.delugeId),
    authorType: dto.authorType,
    authorId: dto.authorId,
    text: dto.text,
    bridge: dto.bridge,
    createdAt: new Date(dto.createdAt),
    updatedAt: new Date(dto.updatedAt),
    attachments: dto.attachments?.map((attachment) => ({
      ...attachment,
      id: AttachmentId(attachment.id),
    })),
  }
}

export const cmpByCreatedAt = Order.mapInput(
  Order.Date,
  (it: Message) => it.createdAt,
)
export const cmpByCreatedAtDesc = Order.flip(cmpByCreatedAt)
